import {AxiosResponse} from 'axios'
import {HttpInstance} from '../createHttpInstance'

export interface RawLogoutResponse {
  Status: 'Failure' | 'Success'
}
export interface Logout<R> {
  (http: HttpInstance): Promise<AxiosResponse<R>>
}

export const logout: Logout<RawLogoutResponse> = (http) =>
  http.post('/v1/auth/logout', {})
